var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.235 7.85008C22.8169 8.45508 23.0068 9.82894 23.0068 9.82894C23.0068 9.82894 23.201 11.4427 23.201 13.0558V14.5686C23.201 16.1823 23.0068 17.7954 23.0068 17.7954C23.0068 17.7954 22.8169 19.1693 22.235 19.7743C21.5697 20.49 20.832 20.5639 20.4151 20.6057C20.3692 20.6103 20.3272 20.6145 20.2896 20.6192C17.5725 20.821 13.4925 20.8273 13.4925 20.8273C13.4925 20.8273 8.44412 20.7799 6.89077 20.6267C6.81717 20.6125 6.72796 20.6015 6.62693 20.5891C6.13489 20.5285 5.36261 20.4334 4.74945 19.7743C4.16755 19.1693 3.97823 17.7954 3.97823 17.7954C3.97823 17.7954 3.78407 16.1823 3.78407 14.5686V13.0558C3.78407 11.4427 3.97823 9.82894 3.97823 9.82894C3.97823 9.82894 4.16755 8.45508 4.74945 7.85008C5.41621 7.13338 6.15459 7.06023 6.57159 7.01892C6.6168 7.01444 6.65823 7.01034 6.69539 7.00583C9.41254 6.80396 13.4883 6.80396 13.4883 6.80396H13.4968C13.4968 6.80396 17.5725 6.80396 20.2896 7.00583C20.3268 7.01034 20.3683 7.01446 20.4135 7.01894C20.8302 7.06025 21.5689 7.13349 22.235 7.85008ZM11.4834 10.8022L11.484 16.4041L16.7296 13.6128L11.4834 10.8022Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.90cef4c35ffabca3299e540dde0deedb.svg";
export { ForwardRef as ReactComponent };